
import React from 'react';
import { motion } from 'framer-motion';
import { Diamond, TrendingUp, Shield, Zap } from 'lucide-react';
import Section from './Section';

interface ValuesSectionProps {
  fadeInUp: any;
  staggerContainer: any;
}

const ValuesSection: React.FC<ValuesSectionProps> = ({
  fadeInUp,
  staggerContainer
}) => {
  const values = [
    {
      icon: Diamond,
      title: "Exclusividade",
      description: "Nem todo mundo entra. Apenas quem compreende o valor do silêncio, da elegância e de uma presença que fala por si."
    },
    {
      icon: TrendingUp,
      title: "Crescimento",
      description: "Relacionamentos que elevam — sua rotina, seus planos, sua ambição. Porque luxo de verdade é viver ao lado de quem soma."
    },
    {
      icon: Shield,
      title: "Confiança",
      description: "Olhares seguros, acordos claros, intenções sem ruído. Aqui, o respeito é o que garante a liberdade do desejo."
    },
    {
      icon: Zap,
      title: "Liberdade",
      description: "Você conduz. Sem julgamentos, sem explicações. Só conexões que acompanham o seu ritmo — e sabem exatamente o que estão fazendo ali."
    }
  ];

  return (
    <Section
      variants={staggerContainer}
      className="justify-center relative overflow-hidden"
    >
      {/* Gradientes luxuosos de fundo com vermelho/rosa/roxo */}
      <div className="absolute inset-0 bg-gradient-to-br from-luxury-mediumPink/5 via-black to-luxury-purple/10"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-gradient-to-r from-luxury-red/10 via-luxury-darkPink/5 to-luxury-purple/10 rounded-full blur-[120px]"></div>
      
      <div className="max-w-6xl mx-auto w-full relative z-10">
        <motion.div variants={fadeInUp} className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Nossos Valores
          </h2>
          <p className="text-lg md:text-xl text-white/70 max-w-4xl mx-auto mb-12">
            Por trás de cada conexão, há códigos silenciosos. 
            <br />
            <span className="text-luxury-mediumPink/90">
              E aqui, eles são levados a sério.
            </span>
          </p>
        </motion.div>

        <motion.div variants={fadeInUp} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-5xl mx-auto">
          {values.map((value, index) => (
            <motion.div key={index} variants={fadeInUp} className="group text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-luxury-red/30 via-luxury-mediumPink/20 to-luxury-purple/30 rounded-2xl flex items-center justify-center mb-4 mx-auto group-hover:scale-110 transition-all duration-300 shadow-lg shadow-luxury-red/10">
                <value.icon className="w-8 h-8 text-luxury-mediumPink" />
              </div>
              <h3 className="text-lg font-bold text-white mb-3">{value.title}</h3>
              <p className="text-white/70 leading-relaxed text-sm">{value.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </Section>
  );
};

export default ValuesSection;
